export var CarModels;
(function (CarModels) {
    CarModels["airplane"] = "airplane";
    CarModels["atv"] = "atv";
    CarModels["boat"] = "boat";
    CarModels["boxVan"] = "boxVan";
    CarModels["car"] = "car";
    CarModels["coupe"] = "coupe";
    CarModels["gelik"] = "gelik";
    CarModels["hatch"] = "hatch";
    CarModels["helicopter"] = "helicopter";
    CarModels["microbus"] = "microbus";
    CarModels["moto"] = "moto";
    CarModels["moto_sport_tour"] = "moto_sport_tour";
    CarModels["pickup"] = "pickup";
    CarModels["porsche"] = "porsche";
    CarModels["prado"] = "prado";
    CarModels["samokat"] = "samokat";
    CarModels["scooter"] = "scooter";
    CarModels["snow_mobile"] = "snow_mobile";
    CarModels["suv"] = "suv";
    CarModels["wagon"] = "wagon";
    CarModels["water_scooter"] = "water_scooter";
})(CarModels || (CarModels = {}));
export const CarModelsTranslate = {
    [CarModels.car]: 'Седан',
    [CarModels.hatch]: 'Хэтчбек',
    [CarModels.suv]: 'Внедорожник',
    [CarModels.gelik]: 'Премиальный внедорожник',
    [CarModels.prado]: 'Внедорожник',
    [CarModels.wagon]: 'Универсал',
    [CarModels.coupe]: 'Купе',
    [CarModels.porsche]: 'Премиальное купе',
    [CarModels.pickup]: 'Пикап',
    [CarModels.boxVan]: 'Грузовичок',
    [CarModels.microbus]: 'Микроавтобус',
    [CarModels.moto]: 'Мотоцикл',
    [CarModels.moto_sport_tour]: 'Мотоцикл спорт-тур',
    [CarModels.scooter]: 'Скутер',
    [CarModels.atv]: 'Квадроцикл',
    [CarModels.boat]: 'Лодка',
    [CarModels.samokat]: 'Самокат',
    [CarModels.snow_mobile]: 'Снегоход',
    [CarModels.water_scooter]: 'Гидроцикл',
    [CarModels.helicopter]: 'Вертолёт',
    [CarModels.airplane]: 'Самолёт',
};
export const PositionPointColor = (props) => {
    switch (props) {
        case CarModels.car:
            return {
                body: { left: 45, top: 50 },
                glass: { left: 62, top: 50 },
                font: { left: 54, top: 5 },
            };
        case CarModels.hatch:
            return {
                body: { left: 45, top: 50 },
                glass: { left: 60, top: 50 },
                font: { left: 53, top: 5 },
            };
        case CarModels.suv:
            return {
                body: { left: 45, top: 50 },
                glass: { left: 62, top: 50 },
                font: { left: 54, top: 5 },
            };
        case CarModels.coupe:
            return {
                body: { left: 43, top: 50 },
                glass: { left: 55, top: 50 },
                font: { left: 49, top: 5 },
            };
        case CarModels.porsche:
            return {
                body: { left: 43, top: 50 },
                glass: { left: 58, top: 50 },
                font: { left: 50, top: 5 },
            };
        case CarModels.gelik:
            return {
                body: { left: 35, top: 50 },
                glass: { left: 59, top: 50 },
                font: { left: 47, top: 5 },
            };
        case CarModels.prado:
            return {
                body: { left: 35, top: 50 },
                glass: { left: 62, top: 50 },
                font: { left: 47, top: 5 },
            };
        case CarModels.pickup:
            return {
                body: { left: 50, top: 50 },
                glass: { left: 67, top: 50 },
                font: { left: 58, top: 5 },
            };
        case CarModels.boxVan:
            return {
                body: { left: 65, top: 50 },
                glass: { left: 75, top: 50 },
                font: { left: 70, top: 5 },
            };
        case CarModels.wagon:
            return {
                body: { left: 40, top: 50 },
                glass: { left: 63, top: 50 },
                font: { left: 52, top: 5 },
            };
        case CarModels.microbus:
            return {
                body: { left: 50, top: 50 },
                glass: { left: 67, top: 50 },
                font: { left: 59, top: 5 },
            };
        default:
            return {
                body: { left: 'none', top: 'none' },
                glass: { left: 'none', top: 'none' },
                font: { left: 'none', top: 'none' },
            };
    }
};
export var ColorPointOptionItem;
(function (ColorPointOptionItem) {
    ColorPointOptionItem["body"] = "body";
    ColorPointOptionItem["glass"] = "glass";
    ColorPointOptionItem["font"] = "font";
})(ColorPointOptionItem || (ColorPointOptionItem = {}));
export const OprionsForModel = (props) => {
    switch (props) {
        case CarModels.car:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.porsche:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.gelik:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.prado:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.hatch:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.suv:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.coupe:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.pickup:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.boxVan:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.wagon:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        case CarModels.microbus:
            return [
                ColorPointOptionItem.body,
                ColorPointOptionItem.glass,
                ColorPointOptionItem.font,
            ];
        default:
            return [];
    }
};
export const titleColorPoint = (point_type) => {
    switch (point_type) {
        case ColorPointOptionItem.body:
            return 'Цвет кузова';
        case ColorPointOptionItem.glass:
            return 'Цвет стёкол';
        case ColorPointOptionItem.font:
            return 'Цвет шрифта';
        default:
            return '';
    }
};
